// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Email API management modal — dark theme matching the LandingPage deployment
   cards it launches from. The rotate-key confirmation uses the standard
   LyricConfirm dialog. */
.email-api-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10040;
  animation: emailApiFade 0.15s ease-in;
}

@keyframes emailApiFade { from { opacity: 0; } to { opacity: 1; } }

.email-api-card {
  background: #11151f;
  border: 1px solid #2a3346;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
  width: 92%;
  max-width: 560px;
  max-height: 88vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #e5e9f0;
  font-family: inherit;
  animation: emailApiSlide 0.18s ease-out;
}

@keyframes emailApiSlide {
  from { transform: translateY(16px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.email-api-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #232b3c;
}

.email-api-brand { font-size: 20px; }
.email-api-header h3 { margin: 0; font-size: 17px; font-weight: 700; color: #fff; }
.email-api-sub { font-size: 12px; color: #8b95a7; margin-top: 2px; }
.email-api-x {
  margin-left: auto;
  background: none;
  border: none;
  color: #8b95a7;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
}
.email-api-x:hover { color: #fff; }

.email-api-body {
  padding: 18px 20px;
  overflow-y: auto;
}

.email-api-muted { color: #8b95a7; font-size: 13px; }
.email-api-muted.small { font-size: 11px; margin-top: 8px; line-height: 1.5; }
.email-api-muted.small code,
.email-api-snippet code { color: #9ecbff; }

.email-api-error {
  background: #2a1a1a;
  border: 1px solid #ef5350;
  color: #ef9a9a;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
}

.email-api-warn {
  background: #2a2410;
  border: 1px solid #d4a017;
  color: #f0d488;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12.5px;
  line-height: 1.5;
  margin-bottom: 14px;
}

.email-api-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.email-api-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8b95a7;
  font-weight: 700;
}

.email-api-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
}
.email-api-badge.on { background: #10331e; color: #66bb6a; border: 1px solid #2e7d43; }
.email-api-badge.off { background: #2a2f3a; color: #9aa4b5; border: 1px solid #3a4258; }

.email-api-keybox {
  background: #0b0e16;
  border: 1px solid #232b3c;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.email-api-key {
  flex: 1 1;
  min-width: 180px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12.5px;
  color: #9ecbff;
  word-break: break-all;
}
.email-api-keybtns { display: flex; gap: 6px; }

.email-api-meta {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #9aa4b5;
  margin-bottom: 14px;
}
.email-api-meta b { color: #cdd5e3; }

/* "Key is auto-injected" confirmation + redeploy-applied note */
.email-api-inject {
  background: #10241a;
  border: 1px solid #2e7d43;
  color: #a9e0bd;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12.5px;
  line-height: 1.5;
  margin-bottom: 14px;
}
.email-api-inject code { color: #9ecbff; }

/* "Redeploy now to apply" prompt shown after enable/rotate on a live app */
.email-api-redeploy {
  background: #0b0e16;
  border: 1px solid #2f5a8a;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.email-api-redeploy-text { flex: 1 1; min-width: 180px; font-size: 12.5px; color: #cdd5e3; line-height: 1.5; }
.email-api-redeploy-text b { color: #fff; }

.email-api-snippet {
  background: #0b0e16;
  border: 1px solid #232b3c;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}
.email-api-snippet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.email-api-snippet pre {
  margin: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11.5px;
  line-height: 1.5;
  color: #c8d1e0;
  white-space: pre-wrap;
  word-break: break-all;
}

.email-api-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.email-api-btn {
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #1a2030;
  color: #cdd5e3;
  border: 1px solid #3a4258;
  transition: all 0.15s;
}
.email-api-btn:hover:not(:disabled) { background: #222a3d; }
.email-api-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.email-api-btn.primary { background: #1a56db; color: #fff; border-color: #1a56db; }
.email-api-btn.primary:hover:not(:disabled) { background: #1648b8; }
.email-api-btn.danger { color: #ef5350; border-color: #ef5350; background: #2a1a1a; }
.email-api-btn.danger:hover:not(:disabled) { background: #331d1d; }

/* Small buttons inside the key box + snippet header */
.email-api-keybtns button,
.email-api-snippet-head button {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  background: #1a2030;
  color: #9ecbff;
  border: 1px solid #2f5a8a;
}
.email-api-keybtns button:hover,
.email-api-snippet-head button:hover { background: #202a3d; }
`, "",{"version":3,"sources":["webpack://./src/components/EmailApiModal.css"],"names":[],"mappings":"AAAA;;yBAEyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;AACvC;;AAEA,0BAA0B,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAElE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,mBAAmB,eAAe,EAAE;AACpC,uBAAuB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAClF,iBAAiB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACnE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,qBAAqB,WAAW,EAAE;;AAElC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB,cAAc,EAAE,eAAe,EAAE;AACpD,yBAAyB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7E;0BAC0B,cAAc,EAAE;;AAE1C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACtF,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEvF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA,qBAAqB,aAAa,EAAE,QAAQ,EAAE;;AAE9C;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA,oBAAoB,cAAc,EAAE;;AAEpC,gEAAgE;AAChE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,yBAAyB,cAAc,EAAE;;AAEzC,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA,2BAA2B,SAAO,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3G,6BAA6B,WAAW,EAAE;;AAE1C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,2DAA2D;EAC3D,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAClF,8CAA8C,mBAAmB,EAAE;AACnE,wBAAwB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACpF,6CAA6C,mBAAmB,EAAE;;AAElE,sDAAsD;AACtD;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;uCACuC,mBAAmB,EAAE","sourcesContent":["/* Email API management modal — dark theme matching the LandingPage deployment\n   cards it launches from. The rotate-key confirmation uses the standard\n   LyricConfirm dialog. */\n.email-api-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10040;\n  animation: emailApiFade 0.15s ease-in;\n}\n\n@keyframes emailApiFade { from { opacity: 0; } to { opacity: 1; } }\n\n.email-api-card {\n  background: #11151f;\n  border: 1px solid #2a3346;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);\n  width: 92%;\n  max-width: 560px;\n  max-height: 88vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  color: #e5e9f0;\n  font-family: inherit;\n  animation: emailApiSlide 0.18s ease-out;\n}\n\n@keyframes emailApiSlide {\n  from { transform: translateY(16px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.email-api-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #232b3c;\n}\n\n.email-api-brand { font-size: 20px; }\n.email-api-header h3 { margin: 0; font-size: 17px; font-weight: 700; color: #fff; }\n.email-api-sub { font-size: 12px; color: #8b95a7; margin-top: 2px; }\n.email-api-x {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #8b95a7;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n}\n.email-api-x:hover { color: #fff; }\n\n.email-api-body {\n  padding: 18px 20px;\n  overflow-y: auto;\n}\n\n.email-api-muted { color: #8b95a7; font-size: 13px; }\n.email-api-muted.small { font-size: 11px; margin-top: 8px; line-height: 1.5; }\n.email-api-muted.small code,\n.email-api-snippet code { color: #9ecbff; }\n\n.email-api-error {\n  background: #2a1a1a;\n  border: 1px solid #ef5350;\n  color: #ef9a9a;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n\n.email-api-warn {\n  background: #2a2410;\n  border: 1px solid #d4a017;\n  color: #f0d488;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  margin-bottom: 14px;\n}\n\n.email-api-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.email-api-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #8b95a7;\n  font-weight: 700;\n}\n\n.email-api-badge {\n  font-size: 12px;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 999px;\n}\n.email-api-badge.on { background: #10331e; color: #66bb6a; border: 1px solid #2e7d43; }\n.email-api-badge.off { background: #2a2f3a; color: #9aa4b5; border: 1px solid #3a4258; }\n\n.email-api-keybox {\n  background: #0b0e16;\n  border: 1px solid #232b3c;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.email-api-key {\n  flex: 1;\n  min-width: 180px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12.5px;\n  color: #9ecbff;\n  word-break: break-all;\n}\n.email-api-keybtns { display: flex; gap: 6px; }\n\n.email-api-meta {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  font-size: 12px;\n  color: #9aa4b5;\n  margin-bottom: 14px;\n}\n.email-api-meta b { color: #cdd5e3; }\n\n/* \"Key is auto-injected\" confirmation + redeploy-applied note */\n.email-api-inject {\n  background: #10241a;\n  border: 1px solid #2e7d43;\n  color: #a9e0bd;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  margin-bottom: 14px;\n}\n.email-api-inject code { color: #9ecbff; }\n\n/* \"Redeploy now to apply\" prompt shown after enable/rotate on a live app */\n.email-api-redeploy {\n  background: #0b0e16;\n  border: 1px solid #2f5a8a;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.email-api-redeploy-text { flex: 1; min-width: 180px; font-size: 12.5px; color: #cdd5e3; line-height: 1.5; }\n.email-api-redeploy-text b { color: #fff; }\n\n.email-api-snippet {\n  background: #0b0e16;\n  border: 1px solid #232b3c;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n.email-api-snippet-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.email-api-snippet pre {\n  margin: 0;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: #c8d1e0;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.email-api-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.email-api-btn {\n  padding: 9px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #1a2030;\n  color: #cdd5e3;\n  border: 1px solid #3a4258;\n  transition: all 0.15s;\n}\n.email-api-btn:hover:not(:disabled) { background: #222a3d; }\n.email-api-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.email-api-btn.primary { background: #1a56db; color: #fff; border-color: #1a56db; }\n.email-api-btn.primary:hover:not(:disabled) { background: #1648b8; }\n.email-api-btn.danger { color: #ef5350; border-color: #ef5350; background: #2a1a1a; }\n.email-api-btn.danger:hover:not(:disabled) { background: #331d1d; }\n\n/* Small buttons inside the key box + snippet header */\n.email-api-keybtns button,\n.email-api-snippet-head button {\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #1a2030;\n  color: #9ecbff;\n  border: 1px solid #2f5a8a;\n}\n.email-api-keybtns button:hover,\n.email-api-snippet-head button:hover { background: #202a3d; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
